/**
 * CustomerAvatar – backward-compatible thin wrapper around the shared AvatarDisplay.
 */
import AvatarDisplay, { type AvatarSize } from '../../../components/feature/avatar/AvatarDisplay';

interface CustomerAvatarProps {
  name?: string | null;
  avatarUrl?: string | null;
  size?: AvatarSize;
  className?: string;
}

export default function CustomerAvatar({ name, avatarUrl, size = 'md', className = '' }: CustomerAvatarProps) {
  return (
    <AvatarDisplay
      name={name}
      avatarUrl={avatarUrl}
      size={size}
      className={className}
    />
  );
}
